import React from 'react';
import { A, Box, Text, PageTitleBox as PTB, MenuIcon } from '../element';
import { ResponsiveMenuIcon } from '../menu';

const MenuIconBox = props => {
  if (props.responsive === 'small') {
    return (
      <MenuIcon direction="row">
        <ResponsiveMenuIcon responsive={props.responsive} onResponsiveMenuIconClick={props.onResponsiveMenuIconClick} />
        <Text data-test-id="page-category">{props.category}</Text>
        {/* To-Do: Added this to make the bottom border to take full width of the viewport. 
        Better way would be to seperate out this component from the PageContentBox
        & make it inherently cover the whole width of viewport. */}
        <Box
          style={{ position: 'absolute', top: '45px', width: '100vw', left: '0px', borderBottom: '1px solid #e6e6e6' }}
        />
      </MenuIcon>
    );
  }
  return null;
};

const PageTitleBox = props => {
  const { downloadUrl, downloadTitle } = props;
  const clsName = props.className ? props.className : '';

  let downloadLink = '';
  const responsiveCls = props.responsive === 'small' ? 'mobile' : '';
  if (downloadUrl && downloadTitle) {
    downloadLink = (
      <A
        data-test-id="title-download-link"
        className="fontSize18 noTextDecoration lightDarkBlue"
        href={downloadUrl}
        target="_blank">
        {downloadTitle}
      </A>
    );
  }
  return (
    <PTB className={`${clsName} ${responsiveCls}`} direction="row-responsive" align="center">
      <MenuIconBox
        responsive={props.responsive}
        category={props.category}
        onResponsiveMenuIconClick={props.onResponsiveMenuIconClick}
      />
      <Box direction="row-responsive" justify="between" align="center" fill={true}>
        <Text data-test-id="page-title">{props.title} </Text>
        {downloadLink}
      </Box>
    </PTB>
  );
};

export default PageTitleBox;
